import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, Platform } from '@ionic/angular';
import { NavigationStart, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AnalyticsService } from '../smoothr-web-app-core/services/analytics/analytics.service';
import { Api } from '../smoothr-web-app-core/api/api';
import { NAVIGATIONURLS, NavigationService } from './services/navigation.service';
import { register } from 'swiper/element/bundle';
import { BrazeService } from './services/braze.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { CookieConsentService } from './services/cookie.service';
import { BehaviorSubject, Observable, catchError, filter, of, switchMap } from 'rxjs';
import Order from 'src/smoothr-web-app-core/models/Order';
import { PaymentStatus } from 'src/smoothr-web-app-core/models/PaymentStatus';
import Payment from 'src/smoothr-web-app-core/models/Payment';
import { InfoModalComponent } from './components/info-modal/info-modal.component';
import { PaymentCancelledModalComponent } from './components/payment-cancelled-modal/payment-cancelled-modal.component';
import { PaymentModalResult } from './components/payment-modal/payment-modal.component';

register();

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
	static largeScreen = false;
	static analyticsEnabled = false;
	isCookieAccepted = false;
	static isWebApp = true;
	static isNativeApp = false;
	public trackAuthUrl$: Observable<{
		order: boolean;
		auth: boolean;
		home: boolean;
		promo: boolean;
	}>;
	public order$ = new BehaviorSubject<Order | null>(null);

	constructor(
		private router: Router,
		private analytics: AnalyticsService,
		platform: Platform,

		private navigationService: NavigationService,
		private brazeService: BrazeService,
		private cookieService: CookieConsentService,
		public translate: TranslateService,
		private repository: RepositoryService,
		private modalController: ModalController,
		private modalCtrl: ModalController
	) {
		console.log(environment.customerGroup + ' ' + environment.version);

		// this.handleCookieConsent();
		const languageValue = localStorage.getItem('langOfApp');
		console.log(languageValue);
		if (languageValue) {
			translate.setDefaultLang(languageValue);
			translate.use(languageValue);
		} else {
			translate.setDefaultLang('de');
			translate.use('de');
		}

		translate.onLangChange.subscribe(languageChanged => {
			if (languageChanged) localStorage.setItem('langOfApp', languageChanged.lang);
		});
		this.repository.obserableOrder.subscribe(order => {
			this.order$.next(order);
		});
		this.trackAuthUrl$ = this.router.events.pipe(
			filter(event => event instanceof NavigationStart),
			switchMap((eventData: NavigationStart) =>
				of({
					auth: eventData?.url?.includes(NAVIGATIONURLS.allInfo()),
					order: eventData?.url?.includes('/' + NAVIGATIONURLS.order()),
					home: eventData?.url?.includes(NAVIGATIONURLS.home()),
					promo: eventData?.url?.includes(NAVIGATIONURLS.promo()),
				})
			),
			catchError(e => {
				return of({
					order: false,
					auth: false,
					home: false,
					promo: false,
				});
			})
		);

		platform.ready().then(() => {
			AppComponent.largeScreen = platform.width() >= 992;
			platform.resize.subscribe(() => {
				AppComponent.largeScreen = platform.width() >= 992;
			});
			try {
				setTimeout(() => {
					console.log('START', document.getElementById('app-root'));
					document.getElementById('app-root').style.opacity = '1';
					document.getElementById('splash-screen')?.remove();
					console.log(new Date());
				}, 4000);
			} catch (e) {}
		});
		Api.isMaintenanceActive()
			.then(result => {
				if (result) {
					this.navigationService.maintenance();
				}
			})
			.catch(error => {
				console.log(error);
			});

		this.checkPayments();
	}
	private disableSdkBraze() {
		this.brazeService.disableSdk();
	}

	ngOnInit() {

		window.addEventListener('pageshow', event => {
			if (event.persisted) {
				console.log('This page was restored from the bfcache.');
				this.checkPayments();
			} else {
				console.log('This page was loaded normally.');
			}
		});
	}

	checkPayments() {
		this.repository.checkOpenPayment().then(async result => {
			if (!result) {
				console.log('No Payment open.', result);
				return;
			}
			console.log(result);
			console.log({
				paymentDone: result.payment?.status === PaymentStatus.done,
				orderIsPaid: result.order?.isPayed,
			});
			if (result.payment?.status === PaymentStatus.done || result.order?.isPayed) {
				console.log('Navigate to payment success.');
				await this.router.navigate(['/payment/success/', result.payment?._id ?? result.order?.paymentId], {
					queryParams: { order: result.payment?.orders[0] ?? result.order?._id },
				});
				return;
			}
			this.showErrorPayment(result.payment, result.order);
		});
	}

	private handleCookieConsent() {
		try {
			this.cookieService.initializeCookieConsent();
		} catch (e) {}
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analytics.setAnalyticsCollectionEnabled(enabled);
	}

	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}
	orderClick() {}
	later() {}

	async showErrorPayment(payment: Payment, order: Order) {
		const retryResponse = await PaymentCancelledModalComponent.show(this.modalCtrl);
		if (!retryResponse) {
			await InfoModalComponent.show(this.modalCtrl, {
				title: this.translate.instant('error_dialog.title'),
				info: this.translate.instant('error_dialog.info'),
				closeButton: this.translate.instant('error_dialog.closeButton'),
			});
			this.repository.payment.next(null);
			return;
		}
		const result = await this.repository.showPaymentModal(
			this.modalCtrl,
			this.repository._venue,
			order,
			this.repository._customerAuth.customer,
			payment.tip,
			false
		);
		if (result?.result === PaymentModalResult.SUCCESS) {
			this.repository.verifiedOrder.emit(order);
			this.repository.payment.emit(result.payment);
			await this.navigationService.paymentSuccess(order._id, result.payment._id);
			return;
		}
	}
}
